import { ThemeContext, ThemeContextData } from '@hb/react'
import { PropsWithChildren } from 'react'

export const ThemeProvider = ({ children, ...props }: PropsWithChildren<ThemeContextData>) => (
  <ThemeContext.Provider value={props}>{children}</ThemeContext.Provider>
)
